import { render, staticRenderFns } from "./ability_system.vue?vue&type=template&id=5e92e21b&scoped=true"
import script from "./ability_system.vue?vue&type=script&lang=js"
export * from "./ability_system.vue?vue&type=script&lang=js"
import style0 from "./ability_system.vue?vue&type=style&index=0&id=5e92e21b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e92e21b",
  null
  
)

export default component.exports